import { Space } from 'antd'
import { useTranslation } from 'react-i18next'
import { InputNumber } from '../InputNumber'
import type { InputNumberProps } from '../InputNumber'

export type WageInputProps = InputNumberProps

export const WageInput = ({ ...restProps }: WageInputProps) => {
  const [t] = useTranslation('antd_ui')
  return (
    <Space.Compact block>
      <InputNumber
        type="number"
        placeholder="#"
        style={{ flexGrow: 1 }}
        {...restProps}
      />
      <Space.Addon>{t('wage_input.currency')}</Space.Addon>
    </Space.Compact>
  )
}
